"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toChildAccess = exports.ChildAccessLevel = void 0;
const apolloComponents_1 = require("../generated/apolloComponents");
var ChildAccessLevel;
(function (ChildAccessLevel) {
    ChildAccessLevel["CookbookOwner"] = "COOKBOOK_OWNER";
})(ChildAccessLevel = exports.ChildAccessLevel || (exports.ChildAccessLevel = {}));
exports.toChildAccess = (owner, currentUserId, accessLevel) => {
    if (owner === currentUserId) {
        return apolloComponents_1.CookbookAccessLevel.Owner;
    }
    if (accessLevel === apolloComponents_1.CookbookAccessLevel.Owner) {
        return ChildAccessLevel.CookbookOwner;
    }
    return accessLevel || apolloComponents_1.CookbookAccessLevel.Viewer;
};
//# sourceMappingURL=toChildAccess.js.map